var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContactServices = function SvgContactServices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 42,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#717888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M33.987 19.196c-.965.29-2.123.41-3.45.41h-6.612c-1.352 0-2.486-.12-3.45-.41.24-2.872 3.184-5.116 6.756-5.116s6.515 2.244 6.756 5.116M31.164 8.192c0 2.172-1.762 3.957-3.933 3.957a3.94 3.94 0 0 1-3.934-3.957 3.92 3.92 0 0 1 3.934-3.934 3.934 3.934 0 0 1 3.933 3.934"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#717888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M23.177 33.048c-1.062-.628-2.462-1.352-3.716-.845-.966.386-1.569 1.906-2.196 2.679-.314.386-.7.458-1.207.265-3.62-1.448-6.394-3.861-8.373-7.191-.338-.507-.29-.917.12-1.4.604-.7 1.352-1.52 1.52-2.461.17-.966-.289-2.076-.675-2.92-.507-1.086-1.062-2.63-2.172-3.258-1.013-.555-2.316-.242-3.21.482-1.544 1.255-2.292 3.234-2.267 5.165 0 .555.072 1.11.193 1.64.313 1.28.917 2.486 1.568 3.62.507.87 1.062 1.69 1.641 2.51 1.93 2.63 4.344 4.923 7.119 6.612 1.4.845 2.895 1.593 4.44 2.124 1.737.58 3.281 1.182 5.164.82 1.978-.361 3.909-1.592 4.681-3.499.241-.555.338-1.182.217-1.785-.265-1.231-1.93-1.955-2.92-2.558z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#717888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M41.299 8.047v8.446c0 3.234-1.641 5.647-4.344 6.612-.82.29-1.737.434-2.702.434H28.63l-6.25 4.175c-.94.604-2.196-.072-2.196-1.158v-3.017c-2.099 0-3.885-.7-5.115-1.93s-1.93-3.017-1.93-5.116V8.047c0-.966.144-1.883.434-2.703C14.513 2.665 16.95 1 20.184 1h14.069c4.222 0 7.046 2.823 7.046 7.047"
  })));
};
export default SvgContactServices;